import React, { useEffect, useState } from 'react';
import { Container, Box, Typography, Paper, Button } from '@mui/material';
import { database } from '../config/firebase';
import { ref, get } from 'firebase/database';
import { accountSyncService } from '../services/accountSyncService';

const TestGroupData: React.FC = () => {
  const [data, setData] = useState<any>({});
  const [groupMembers, setGroupMembers] = useState<any>({});

  const loadData = async () => {
    try {
      // accountGroups 데이터 로드
      const accountGroupsRef = ref(database, 'accountGroups');
      const accountGroupsSnapshot = await get(accountGroupsRef);
      const accountGroups = accountGroupsSnapshot.val() || {};

      // phoneToGroup 데이터 로드
      const phoneToGroupRef = ref(database, 'phoneToGroup');
      const phoneToGroupSnapshot = await get(phoneToGroupRef);
      const phoneToGroup = phoneToGroupSnapshot.val() || {};

      // driversm2 데이터 로드 (전화번호만)
      const driversRef = ref(database, 'driversm2');
      const driversSnapshot = await get(driversRef);
      const drivers = driversSnapshot.val() || {};
      
      // 드라이버 전화번호 목록
      const driverPhones = Object.keys(drivers);

      // 각 전화번호에 대해 그룹 멤버 확인
      const membersByPhone: any = {};
      for (const phone of driverPhones) {
        const members = await accountSyncService.getGroupMembers(phone);
        if (members.length > 0) {
          membersByPhone[phone] = members;
        }
      }

      setData({
        accountGroups,
        phoneToGroup,
        driverPhones,
      });
      setGroupMembers(membersByPhone);
    } catch (error) {
      console.error('데이터 로드 실패:', error);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          그룹 데이터 테스트
        </Typography>
        
        <Button onClick={loadData} variant="contained" sx={{ mb: 2 }}>
          데이터 새로고침
        </Button>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6">accountGroups:</Typography>
          <pre style={{ overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(data.accountGroups, null, 2)}
          </pre>
        </Paper>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6">phoneToGroup:</Typography>
          <pre style={{ overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(data.phoneToGroup, null, 2)}
          </pre>
        </Paper>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6">드라이버 전화번호 목록:</Typography>
          <pre style={{ overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(data.driverPhones, null, 2)}
          </pre>
        </Paper>

        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6">각 전화번호별 그룹 멤버:</Typography>
          <pre style={{ overflow: 'auto', fontSize: '12px' }}>
            {JSON.stringify(groupMembers, null, 2)}
          </pre>
        </Paper>
      </Box>
    </Container>
  );
};

export default TestGroupData;